import React from 'react';
import { AppSidebar } from '@nsi-advisory-services/components';
import { useAuthSession } from '@nsi-advisory-services/auth-react';
import ProfilePhoto from '../employees/ProfilePhoto';
import useNavItems from './navItems';

const SUITE_APPS = [
  {
    key: 'bdc',
    label: 'BizDev Connect',
    href: 'https://bizdevconnect.nsieng.com/',
    iconImageSrc: '/res/biz_dev_connect_logo.png',
    icon: 'bi-grid',
  },
  {
    key: 'ppc',
    label: 'ProPlan Connect',
    href: 'https://ppc.nsieng.com/',
    iconImageSrc: '/res/ppc.png',
    icon: 'bi-kanban',
  },
  {
    key: 'pc',
    label: 'Pursuit Connect',
    href: 'https://pursuitconnect.nsieng.com/',
    iconImageSrc: '/res/pc_logo_192.png',
    icon: 'bi-briefcase',
  },
  {
    key: 'riims',
    label: 'RIIMS',
    href: 'https://riimsapp.nsieng.com/',
    iconImageSrc: '/res/riims_logo_512.png',
    icon: 'bi-graph-up-arrow',
  },
  {
    key: 'ems',
    label: 'Employee Connect',
    href: 'https://employeeconnect.nsieng.com/',
    iconImageSrc: '/res/employee_connnect_logo_transparent.png',
    icon: 'bi-people',
    current: true,
  },
  {
    key: 'h9',
    label: 'H9 Online',
    href: 'https://h9online.nsieng.com',
    iconImageSrc: '/res/h9_logo.png',
    icon: 'bi-lightning-charge',
  },
];

export default function Sidebar({ collapsed, onToggle }) {
  const { user, signOut } = useAuthSession();
  const items = useNavItems();

  return (
    <AppSidebar
      collapsed={collapsed}
      onToggle={onToggle}
      appName="Employee Connect"
      logoSrc="/logo512.png"
      homePath="/me"
      items={items}
      apps={SUITE_APPS}
      user={user ? { name: user.name, email: user.email } : null}
      avatar={<ProfilePhoto employeeId="me" size="small" />}
      onSignOut={signOut}
    />
  );
}
